<template>
  <div>
    <Nav> </Nav>

    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h2>Bienvenido a la administraciòn central del Punto de Venta</h2>
        </b-col>
      </b-row>
      <ReportSearchBar v-if="this.hasPermission('rrn:central:reports:dailyReport') || this.hasPermission('rrn:central:reports:productPopularity')" :emitOnChange="false" @search="searchRecv"></ReportSearchBar>
      <b-row>
        <b-col>
          <p>Selecciona una de las opciones del menu principal</p>
        </b-col>
      </b-row>
      <b-row v-if="this.hasPermission('rrn:central:reports:dailyReport')" >
        <b-col>
          <h3>Ventas</h3>
        </b-col>
      </b-row>
      <b-row v-if="this.hasPermission('rrn:central:reports:dailyReport')" >
        <b-col cols="12">
          <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
            <b-row>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Ventas
                    Totales</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ '$' + ventasSum.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

        </b-col>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Ticket
                    promedio</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ '$' + avgTicket.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Promedio x
                    persona</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ '$' + avgTicketPp.toLocaleString('en-US')
                    }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white"># de
                    cuentas</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ ticketsSum.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default border-0">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white"># de
                    comensales</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ comensales.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default border-0">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Comensales
                    promedio</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ avgcomensales.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

        </b-col>
            </b-row>
          </b-overlay>
        </b-col>
      </b-row>
      <b-row v-if="this.hasPermission('rrn:central:reports:dailyReport')" >
        <b-col>
          <h3>Metas</h3>
        </b-col>
      </b-row>
      <b-row v-if="this.hasPermission('rrn:central:reports:dailyReport')" >
        <b-col cols="12">
          <b-overlay :show="salesReportLoading || projectedLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
            <b-row>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body class="bg-gradient-default">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Meta</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">${{ metadelPeriodo.toLocaleString('en-US') }}</span>
                </b-col>
                <b-col md="auto">
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="6" lg="4" xl="2">
          <b-card no-body
            :bg-variant="attainment.percentage >= 100 ? 'success' : attainment.percentage < 80 ? 'danger' : 'warning'">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Porcentaje
                    Alcanzado</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ attainment.percentage.toLocaleString('en-US')
                    }} %</span>
                </b-col>
                <b-col md="auto">

                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

            </b-row>
          </b-overlay>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="this.hasPermission('rrn:central:reports:dailyReport')"
          cols="12"
          md="12"
          :lg="showSucursalBreakdown ? 9 : 12"
        >
          <b-card>
            <b-row align-v="center">
              <b-col>
                <h3 class="mb-0">Ventas Totales {{ salesChartHeading }} {{ show_initDate }} al {{ show_lastDate }} </h3>
                <small v-if="salesChartGranularity === 'auto'" class="text-muted">
                  Granularidad automática · {{ daysCount }} día{{ daysCount === 1 ? '' : 's' }} en el rango
                </small>
              </b-col>
              <b-col cols="auto" style="min-width: 180px;">
                <b-form-group label="Granularidad" label-size="sm" class="mb-0">
                  <b-form-select size="sm" v-model="salesChartGranularity" :options="salesGranularityOptions"
                    @change="rebuildSalesChart"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-overlay :show="salesReportLoading || projectedLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-row>
                <b-col>
                  <LineChart :show="nsalesChart.show" :datasets="nsalesChart.datasets" :labels="nsalesChart.labels">
                  </LineChart>
                </b-col>
              </b-row>
            </b-overlay>

          </b-card>
        </b-col>
        <b-col v-if="showSucursalBreakdown && this.hasPermission('rrn:central:reports:dailyReport')" cols="12" md="12" lg="3">
          <b-card>
            <b-row>
              <b-col>
                <h3>Ventas por Sucursal {{ show_initDate }} al {{ show_lastDate }} </h3>
              </b-col>
            </b-row>
            <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-row>
                <b-col>
                  <DoughnutChart :show="salesBySucursalDonutChart.show" :datasets="salesBySucursalDonutChart.datasets"
                    :labels="salesBySucursalDonutChart.labels">
                  </DoughnutChart>
                </b-col>
              </b-row>
            </b-overlay>


          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showSucursalBreakdown">
        <b-col v-if="this.hasPermission('rrn:central:reports:dailyReport')" cols="12" md="12" lg="9">
          <b-card>
            <b-row>
              <b-col>
                <h3>Ventas por {{ group_type }} {{ show_initDate }} al {{ show_lastDate }} </h3>

              </b-col>
            </b-row>
            <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-row>
                <b-col>
                  <LineChart :datasets="salesBySucursalLineChart.datasets" :show="salesBySucursalLineChart.show"
                    :options="salesBySucursalLineChart.options" :labels="salesBySucursalLineChart.labels">
                  </LineChart>
                </b-col>
              </b-row>
            </b-overlay>

          </b-card>
        </b-col>
        <b-col v-if="this.hasPermission('rrn:central:reports:dailyReport')" cols="12" md="12" lg="3">
          <b-card>
            <b-row>
              <b-col>
                <h3>Comensales por Sucursal {{ show_initDate }} al {{ show_lastDate }} </h3>
              </b-col>
            </b-row>
            <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-row>
                <b-col>
                  <DoughnutChart :show="comensalesBySucursalDonutChart.show"
                    :datasets="comensalesBySucursalDonutChart.datasets" :labels="comensalesBySucursalDonutChart.labels">
                  </DoughnutChart>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="this.hasPermission('rrn:central:reports:dailyReport')" cols="12">
          <b-card>
            <b-row>
              <b-col>
                <h3>Ventas por Área {{ show_initDate }} al {{ show_lastDate }}</h3>
                <small class="text-muted" v-if="salesByAreaTotal > 0">
                  Total: {{ '$' + salesByAreaTotal.toLocaleString('en-US') }}
                </small>
              </b-col>
            </b-row>
            <b-overlay :show="salesByAreaLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-row>
                <b-col lg="4" md="6" cols="12">
                  <DoughnutChart :show="salesByAreaDonutChart.show" :datasets="salesByAreaDonutChart.datasets"
                    :labels="salesByAreaDonutChart.labels">
                  </DoughnutChart>
                </b-col>
                <b-col lg="8" md="6" cols="12">
                  <b-table
                    small
                    striped
                    hover
                    responsive
                    sort-by="total"
                    :sort-desc="true"
                    :items="salesByAreaTable"
                    :fields="salesByAreaFields"
                    empty-text="Sin ventas en el rango"
                    show-empty
                  >
                    <template #cell(rank)="row">{{ row.index + 1 }}</template>
                    <template #cell(total)="row">$ {{ row.item.total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                    <template #cell(avg_ticket)="row">$ {{ row.item.avg_ticket.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                    <template #cell(avg_per_person)="row">$ {{ row.item.avg_per_person.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                    <template #cell(share)="row">{{ row.item.share.toFixed(1) }}%</template>
                  </b-table>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="showSucursalBreakdown && this.hasPermission('rrn:central:reports:dailyReport')">
        <b-col cols="12">
          <b-card no-body class="p-3">
            <b-row align-v="center" class="mb-2">
              <b-col>
                <h3 class="mb-0">Ranking de sucursales {{ show_initDate }} al {{ show_lastDate }}</h3>
              </b-col>
              <b-col cols="auto">
                <b-form-input
                  size="sm"
                  type="search"
                  v-model="sucursalRankingSearch"
                  placeholder="Buscar sucursal…"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-table
                small
                striped
                hover
                responsive
                sort-by="total"
                :sort-desc="true"
                :filter="sucursalRankingSearch"
                :fields="sucursalRankingFields"
                :items="sucursalRanking"
                empty-text="Sin datos en el rango"
                show-empty
              >
                <template #cell(rank)="row">{{ row.index + 1 }}</template>
                <template #cell(total)="row">$ {{ row.item.total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                <template #cell(avg_ticket)="row">$ {{ row.item.avg_ticket.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                <template #cell(avg_per_person)="row">$ {{ row.item.avg_per_person.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</template>
                <template #cell(share)="row">{{ row.item.share.toFixed(1) }}%</template>
              </b-table>
            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col v-if="this.hasPermission('rrn:central:reports:dailyReport')" cols="12" md="6" lg="3">
          <b-card no-body class="p-3">
            <h3>Por dia</h3>
            <b-overlay :show="salesReportLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-table small striped hover sticky-header="50vh" :fields="tableSales.headers"
                :items="tableSales.data"></b-table>
            </b-overlay>
          </b-card>
        </b-col>

        <b-col v-if="this.hasPermission('rrn:central:reports:productPopularity')" cols="12" md="6" lg="9">
          <b-card no-body class="p-3">
            <h3>
              Popularidad {{ show_initDate }} al {{ show_lastDate }}
              <b-spinner v-if="popularidadLoading" small variant="primary" class="ml-2"></b-spinner>
            </h3>
            <b-overlay :show="popularidadLoading" rounded="sm" opacity="0.6" spinner-variant="primary">
              <b-table small striped sort-by="quantity" :sort-desc="true" hover sticky-header="50vh"
                :per-page="pop_byPage" :current-page="pop_page" :fields="tablePopularidad.headers"
                :items="tablePopularidad.data"></b-table>

              <b-pagination v-model="pop_page" :total-rows="tablePopularidad.data.length" :per-page="pop_byPage"
                aria-controls="my-table"></b-pagination>
            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>


<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import moment from 'moment';
// import { D3BarChart } from 'vue-d3-charts';
import ReportSearchBar from "./reports/searchBar/ReportSearchBar.vue";
import DoughnutChart from "../components/Graphs/DoughnutChart.vue"
import LineChart from "../components/Graphs/LineChart.vue";
import _ from 'lodash';
export default {
  name: "Dashboard",
  components: { Nav, ReportSearchBar, DoughnutChart, LineChart },
  watch: {
  },
  computed: {
    // Whether the "by sucursal" breakdowns (donuts + per-sucursal line)
    // add information. With a single sucursal selected they collapse to
    // 100% of one slice / one flat line, so we hide them. An empty
    // array (no filter = all sucursales) also satisfies > 1 conceptually,
    // but the existing line chart already used `> 1` so we keep the
    // same threshold across the three widgets for consistency.
    showSucursalBreakdown() {
      return this.allSucsArray.length > 1
    },
    // daysCount is already a data prop set inside searchRecv. We expose
    // the granularity selection as computeds that read from it so the
    // chart updates reactively when the user flips the selector without
    // having to re-fetch from the backend.
    autoSalesGranularity() {
      const n = this.daysCount
      if (n > 90) return "monthly"
      if (n > 30) return "weekly"
      return "daily"
    },
    resolvedSalesGranularity() {
      return this.salesChartGranularity === "auto"
        ? this.autoSalesGranularity
        : this.salesChartGranularity
    },
    salesChartHeading() {
      switch (this.resolvedSalesGranularity) {
        case "monthly": return "por mes"
        case "weekly": return "por semana"
        default: return "por día"
      }
    },
  },
  data() {
    return {
      projectedSales: [],
      show_initDate: "",
      show_lastDate: "",
      group_type: "daily",
      pop_byPage: 11,
      pop_page: 1,
      loading: false,
      // Per-section loading flags. b-overlay reads these so each card
      // shows its own spinner instead of the whole page feeling frozen.
      // salesReportLoading covers /report/dates which feeds ~6 widgets
      // (KPIs, the totals chart, the per-sucursal charts, the ranking,
      // the daily table); projectedLoading covers /report/projections
      // (the "Proyectado" line on the totals chart); popularidadLoading
      // covers the popularity table (which is the slow one — see
      // reports_popularidad_Model: 9M+ rows in ticket_products).
      // salesByAreaLoading already exists below.
      salesReportLoading: false,
      projectedLoading: false,
      popularidadLoading: false,
      daysCount: 0,
      allSucsArray: [],
      weekLbls: [],
      monthLbls: [],
      comensales: 0,
      ventasSum: 0,
      ticketsSum: 0,
      avgTicket: 0,
      avgTicketPp: 0,
      avgcomensales: 0,
      metadelPeriodo: 0,
      attainment: {
        percentage: 0
      },
      tableSales: {
        data: [],
        headers: [
          { key: "fecha", label: "Fecha", sortable: true },
          { key: "total", label: "Total", sortable: true }
        ]
      },
      tablePopularidad: {
        data: [],
        headers: [
          { key: "ndescription", label: "Nombre", sortable: true },
          { key: "quantity", label: "Cantidad", sortable: true },
          { key: "restaurant_area_name", label: "Area", sortable: true },
        ]
      },
      colorsArray: [
        "#FF5733", "#FFC300", "#FFDC00", "#F4D03F", "#28B463",
        "#3498DB", "#5DADE2", "#85C1E9", "#A569BD", "#F1948A",
        "#D98880", "#CD6155", "#EC7063", "#AF7AC5", "#A569BD",
        "#5499C7", "#5DADE2", "#48C9B0", "#45B39D", "#52BE80",
        "#58D68D", "#F7DC6F", "#F4D03F", "#FF5733", "#F5B041",
        "#DC7633", "#BA4A00", "#E74C3C", "#C0392B", "#922B21",
        "#6E2C00", "#AF601A", "#935116", "#784212", "#5B2C6F",
        "#4A235A", "#7D3C98", "#5B2C6F", "#4A235A", "#7D3C98",
        "#5B2C6F", "#4A235A", "#7D3C98", "#5B2C6F", "#4A235A",
        "#7D3C98", "#5B2C6F", "#4A235A", "#7D3C98", "#5B2C6F",
      ],
      sucursales: [],
      salesBySucursal: [],
      salesReport: [],
      comensalesBySucursalDonutChart: {
        show: true,
        datasets: [{
          data: [],
          borderColor: '#fafafa',
          backgroundColor: [
          ],
          borderWidth: 2
        }],
        labels: []
      },
      salesBySucursalDonutChart: {
        show: true,
        datasets: [{
          data: [],
          borderColor: '#fafafa',
          backgroundColor: [
          ],
          borderWidth: 2
        }],
        labels: []
      },
      salesByAreaDonutChart: {
        show: true,
        datasets: [{
          data: [],
          borderColor: '#fafafa',
          backgroundColor: [],
          borderWidth: 2
        }],
        labels: []
      },
      salesByAreaTable: [],
      // Columns mirror the sucursal ranking table so the operator reads
      // both reports the same way (same order, same units, same formats).
      salesByAreaFields: [
        { key: "rank", label: "#", sortable: false },
        { key: "area", label: "Área", sortable: true },
        { key: "total", label: "Ventas", sortable: true, class: "text-right" },
        { key: "operaciones", label: "Tickets", sortable: true, class: "text-right" },
        { key: "comensales", label: "Comensales", sortable: true, class: "text-right" },
        { key: "avg_ticket", label: "Ticket prom.", sortable: true, class: "text-right" },
        { key: "avg_per_person", label: "Por persona", sortable: true, class: "text-right" },
        { key: "share", label: "% del total", sortable: true, class: "text-right" },
      ],
      salesByAreaTotal: 0,
      salesByAreaLoading: false,
      // Per-sucursal ranking. Built client-side from salesReport which is
      // already aggregated by (sucursal, day) in MySQL, so this is one
      // O(n) pass with no nested groupBys — safe even with hundreds of
      // sucursales over a year.
      sucursalRanking: [],
      sucursalRankingSearch: "",
      sucursalRankingFields: [
        { key: "rank", label: "#", sortable: false },
        { key: "nombre", label: "Sucursal", sortable: true },
        { key: "total", label: "Ventas", sortable: true, class: "text-right" },
        { key: "operaciones", label: "Tickets", sortable: true, class: "text-right" },
        { key: "comensales", label: "Comensales", sortable: true, class: "text-right" },
        { key: "avg_ticket", label: "Ticket prom.", sortable: true, class: "text-right" },
        { key: "avg_per_person", label: "Por persona", sortable: true, class: "text-right" },
        { key: "share", label: "% del total", sortable: true, class: "text-right" },
      ],
      // Granularity for the "Ventas Totales" line chart. "auto" follows the
      // same daysCount thresholds the per-sucursal line chart uses (>90 →
      // monthly, >30 → weekly, otherwise daily); the user can pin a fixed
      // mode to override that. Stored separately from group_type because
      // group_type also drives the per-sucursal chart and we don't want
      // the two to be coupled when only one is changed.
      salesChartGranularity: "auto",
      salesGranularityOptions: [
        { value: "auto", text: "Automática" },
        { value: "daily", text: "Por día" },
        { value: "weekly", text: "Por semana" },
        { value: "monthly", text: "Por mes" },
      ],
      // Bucketed totals stored as { key: amount }. Kept around so changing
      // the granularity (or the projection arriving after the totals) can
      // re-render the chart without re-fetching.
      salesByDayMap: {},
      projectedByDayMap: {},
      salesBySucursalLineChart: {
        show: true,
        datasets: [],
        labels: [],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              type: 'time',
            },
          }
        }
      },
      nsalesChart: {
        show: true,
        datasets: [{
          label: 'Ventas Totales',
          data: [],
          fill: false,
          borderColor: '#172b4d',
          backgroundColor: '#172b4d',
          borderWidth: 5
        }, {
          label: 'Proyectado',
          data: [],
          fill: false,
          borderColor: '#2dce89',
          backgroundColor: '#2dce89',
          borderWidth: 5
        }
        ],
        labels: []
      },
      salesChart: {
        chart_title: "Ventas",
        chartData: [],
        config: {
          key: "date",
          values: ["total"],
          tooltip: { label: "total" },
          labelRotation: 45,
          color: {
            default: '#222f3e',
            current: '#41B882'
          }
        },
      },
      initialDate: null,
      lastDate: null,
      minLastDate: null
    };
  },
  mounted() {
    this.getSucursals()
    moment().locale("es-mx")
    this.initialDate = moment().subtract(7, "days").format()
    this.lastDate = moment().add(1, "days").format()
    this.minLastDate = moment(this.initialDate).add(1, 'days').format()
    console.log("dailyReport"+this.hasPermission('rrn:central:reports:dailyReport'))
    // let that = this
    // setTimeout(function () { that.changeDate() }, 300)
  },
  methods: {
    searchRecv(p) {
      console.log("valchanged")
      console.log(p)
      this.initialDate = p.initDate
      this.lastDate = p.endDate
      let i = moment(p.initDate)
      let e = moment(p.endDate)
      this.daysCount = e.diff(i, 'days')
      if (this.daysCount > 90) {
        this.group_type = "monthly"
      } else if (this.daysCount > 30) {
        this.group_type = "weekly"
      } else if (this.daysCount > 0) {
        this.group_type = "daily"
      }
      this.allSucsArray = p.sucursales
      this.changeDate()
    },
    // bucketKeyForDateAt maps a date string to its bucket key for the
    // given granularity. Used by both the Ventas Totales chart and the
    // per-sucursal line chart so labels and dataset x-values stay aligned
    // — that alignment is what lets Chart.js know which point goes in
    // which column, and is what zero-fill below depends on.
    //
    // Formats match the existing yearmonth/weekyear fields the data
    // preparation in getsalesreport emits, so old code paths keep working
    // unchanged.
    bucketKeyForDateAt(dateStr, granularity) {
      const m = moment(dateStr)
      switch (granularity) {
        case "monthly":
          return m.year() + "-" + m.format("M") // e.g. 2025-11, 2026-1
        case "weekly":
          return m.year() + "-" + m.isoWeek() // e.g. 2025-45
        default:
          return m.format("YYYY-MM-DD")
      }
    },
    // buildBucketKeysAt returns the ordered, de-duplicated list of bucket
    // keys (= x-axis labels) that cover [initialDate, lastDate] at the
    // requested granularity.
    buildBucketKeysAt(granularity) {
      const keys = []
      const seen = new Set()
      const cursor = moment(this.initialDate)
      const end = moment(this.lastDate)
      while (cursor.isSameOrBefore(end, "day")) {
        const k = this.bucketKeyForDateAt(cursor.format("YYYY-MM-DD"), granularity)
        if (!seen.has(k)) {
          seen.add(k)
          keys.push(k)
        }
        cursor.add(1, "day")
      }
      return keys
    },
    // Convenience wrappers for the Ventas Totales chart's resolved
    // granularity (kept so older call sites — getsalesreport,
    // getProjectedReport, rebuildSalesChart — read clearly).
    bucketKeyForDate(dateStr) {
      return this.bucketKeyForDateAt(dateStr, this.resolvedSalesGranularity)
    },
    buildSalesBucketKeys() {
      return this.buildBucketKeysAt(this.resolvedSalesGranularity)
    },
    setDateRange() {
      let firstDate = this.initialDate, lastDate = this.lastDate
      let date = moment(firstDate)
      const dates = [date.format('YYYY-MM-DD')];
      do {
        date = moment(date).add(1, 'day');
        dates.push(date.format('YYYY-MM-DD'));
      } while (moment(date).isBefore(lastDate));
      this.salesBySucursalLineChart.show = false
      this.salesBySucursalLineChart.labels = dates
      // nsalesChart.labels follows the *resolved* granularity for the
      // Ventas Totales chart; getsalesreport and getProjectedReport bucket
      // their data into the same keys so a single index aligns both
      // datasets with the labels.
      this.nsalesChart.labels = this.buildSalesBucketKeys()

      let initDate = moment(firstDate)
      let endDate = moment(lastDate)

      this.show_initDate = initDate.format('YYYY-MM-DD')
      this.show_lastDate = endDate.format('YYYY-MM-DD')

      let months = endDate.diff(initDate, "months")
      let moLbls = []
      let yr = initDate.year()
      let mo = initDate.month()
      for (var i = 0; i < months; i++) {
        if (mo > 12) {
          mo = 1
          yr++
        }
        moLbls.push(yr + "-" + mo)
        mo++
      }
      this.monthLbls = moLbls

      let weeks = endDate.diff(initDate, "weeks")
      let wkLbls = []
      yr = initDate.year()
      let wk = initDate.week()
      for (i = 0; i < weeks; i++) {
        let wksinYr = moment(yr).weeksInYear()
        if (wk > wksinYr) {
          yr++
          wk = 1
        }
        wkLbls.push(yr + "-" + wk)
        wk++
      }
      this.weekLbls = wkLbls
      console.log("Date SET")
    },
    calculateAttainment() {
      this.attainment.percentage = this.ventasSum * 100 / this.metadelPeriodo
    },
    getProjectedReport() {
      console.log("getProjectedReport")
      this.loading = true
      this.projectedLoading = true
      let that = this
      that.nsalesChart.show = false
      that.nsalesChart.datasets[1].data = []
      axios.post("/report/projections", { initial_date: moment(this.initialDate).format("YYYY-MM-DD"), end_date: moment(this.lastDate).subtract(1, 'day').format("YYYY-MM-DD"), sucursales: this.allSucsArray })
        .then(function (r) {
          console.log("report got getProjectedReport")
          let d = r.data.map(function (r) {
            let m = moment(r.date)
            return { ...r, week: m.isoWeek(), year: m.year(), month: parseInt(m.format("M")), weekyear: m.year() + "-" + m.isoWeek(), yearmonth: m.year() + "-" + m.format("M") }
          })
          that.projectedSales = d
          // Bucket by raw date first (so the cached map can be re-grouped
          // when the user changes the granularity selector without
          // re-fetching). projectedByDayMap stays at the daily resolution;
          // rebuildSalesChart collapses it into the requested buckets.
          const dayMap = {}
          let meta = 0
          r.data.forEach((row) => {
            const amount = row.amount || 0
            dayMap[row.date] = (dayMap[row.date] || 0) + amount
            meta += amount
          })
          that.projectedByDayMap = dayMap
          that.metadelPeriodo = meta
          that.calculateAttainment()
          that.rebuildSalesChart()
          that.nsalesChart.show = true
          that.loading = false
          console.log("getProjectedReport report done")
        }).catch(function (err) {
          console.error(err.response)
          that.makeToast("Error", err.response.data, "danger");
        })
        .finally(() => {
          that.projectedLoading = false
        })
    },
    getPopularidad() {
      this.pop_page = 1
      let that = this
      that.tablePopularidad.data = []
      let queryparam = { initial_date: moment(that.initialDate).format("YYYY-MM-DD"), end_date: moment(that.lastDate).format("YYYY-MM-DD"), sucursales: this.allSucsArray }
      console.log(queryparam)
      if(!this.hasPermission("rrn:central:reports:productPopularity")){
        return
      }
      that.popularidadLoading = true
      axios
        .post("/report/popularidad", queryparam)
        .then(function (response) {
          that.tablePopularidad.data = response.data;
          console.log("get popularidad")
          console.log(queryparam)
          console.log(response.data)
        })
        .catch(function (err) {
          console.error(err);
          that.makeToast("Error", err.response.data, "danger");
        })
        .finally(() => {
          that.popularidadLoading = false
        })
    },
    getsalesreport() {
      if(!this.hasPermission("rrn:central:reports:dailyReport")){
        return
      }
      console.log("getSalesreport")
      this.loading = true
      this.salesReportLoading = true
      let that = this
      this.salesReport = []
      that.nsalesChart.show = false
      that.nsalesChart.datasets[0].data = []
      that.ticketsSum = 0
      that.avgTicketPp = 0
      that.avgTicket = 0
      that.avgcomensales = 0
      axios.post("/report/dates", { initial_date: moment(this.initialDate).format("YYYY-MM-DD"), end_date: moment(this.lastDate).format("YYYY-MM-DD"), sucursales: this.allSucsArray })
        .then(function (r) {
          console.log("report got")
          let d = r.data.map(function (r) {
            let m = moment(r.date)
            return { ...r, week: m.isoWeek(), year: m.year(), month: parseInt(m.format("M")), weekyear: m.year() + "-" + m.isoWeek(), yearmonth: m.year() + "-" + m.format("M") }
          })
          that.salesReport = d
          that.setVentasPorSucursal()
          that.setVentasPorsucursalPorDia()
          let comen = r.data.reduce(function (p, a) {
            return p + a.comensales
          }, 0)
          that.comensales = Math.round((comen + Number.EPSILON) * 100) / 100
          let venSum = r.data.reduce(function (p, a) {
            return p + a.total
          }, 0)
          that.ventasSum = Math.round((venSum + Number.EPSILON) * 100) / 100
          that.calculateAttainment()
          let tSum = r.data.reduce(function (p, a) {
            return p + a.operaciones
          }, 0)
          that.ticketsSum = Math.round((tSum + Number.EPSILON) * 100) / 100
          that.avgTicketPp = Math.round(((that.ventasSum / that.comensales) + Number.EPSILON) * 100) / 100
          that.avgTicket = Math.round(((that.ventasSum / that.ticketsSum) + Number.EPSILON) * 100) / 100
          that.avgcomensales = Math.round(((that.comensales / that.ticketsSum) + Number.EPSILON) * 100) / 100

          // Daily totals cached as { 'YYYY-MM-DD': amount }. Stored so the
          // chart can be re-bucketed when the granularity selector changes
          // without hitting the backend again.
          const dayMap = {}
          r.data.forEach((row) => {
            dayMap[row.date] = (dayMap[row.date] || 0) + (row.total || 0)
          })
          that.salesByDayMap = dayMap

          // Per-day table stays daily (it's an explicit breakdown). The
          // line chart goes through rebuildSalesChart which honors the
          // resolved granularity.
          const dailyRows = Object.keys(dayMap)
            .sort((a, b) => new Date(a) - new Date(b))
            .map((d) => ({ date: d, total: dayMap[d] }))
          that.salesChart.chartData = dailyRows
          that.tableSales.data = dailyRows.map((x) => ({
            fecha: x.date,
            total: "$ " + x.total.toLocaleString("en-US"),
          }))

          that.rebuildSalesChart()
          that.nsalesChart.show = true
          that.loading = false
          console.log("sales report done")
        }).catch(function (err) {
          console.log("sales report err")
          console.error(err.response.data)
          that.makeToast("Error", err.response.data, "danger");
        })
        .finally(() => {
          that.salesReportLoading = false
        })
    },
    getSucursals() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          that.sucursales = response.data
        })
        .catch(function (err) {
          console.error(err)
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    setVentasPorsucursalPorDia() {
      const that = this
      const base = this.salesReport
      that.salesBySucursalLineChart.show = false
      that.salesBySucursalLineChart.datasets = []

      // Build the full list of bucket keys for the resolved range/
      // granularity ONCE. Every sucursal dataset then emits one point per
      // key in this list — missing buckets become explicit zeros instead
      // of gaps. This is what fixes the "line jumps from Jan straight to
      // Apr" effect when a sucursal didn't have sales for a month.
      const granularity = that.group_type
      const bucketKeys = that.buildBucketKeysAt(granularity)
      that.salesBySucursalLineChart.labels = bucketKeys

      let clrid = 0
      const datasets = _(base)
        .groupBy("sucursal_id")
        .map(function (rows, s_id) {
          const suc = _.find(that.sucursales, (s) => s.id == s_id)
          const lbl = suc != undefined ? suc.nombre : ""
          if (clrid >= that.colorsArray.length) clrid = 0
          const clr = that.colorsArray[clrid]
          clrid++

          // Sum each sucursal's totals into a map keyed by bucket. Doing
          // it with a plain forEach keeps this O(rows) — same big-O as
          // the previous lodash chain but with one pass instead of two.
          const totals = {}
          for (const r of rows) {
            const k = that.bucketKeyForDateAt(r.date, granularity)
            totals[k] = (totals[k] || 0) + (r.total || 0)
          }

          return {
            borderColor: clr,
            backgroundColor: clr,
            label: lbl,
            sucursal_id: s_id,
            data: bucketKeys.map((k) => ({ x: k, y: totals[k] || 0 })),
          }
        })
        .value()

      that.salesBySucursalLineChart.datasets = datasets
      that.salesBySucursalLineChart.show = true
    },
    setVentasPorSucursal() {
      let that = this
      this.salesBySucursalDonutChart.show = false
      this.comensalesBySucursalDonutChart.show = false
      this.salesBySucursalDonutChart.labels = []
      this.salesBySucursalDonutChart.datasets[0].data = []
      let base = this.salesReport
      // Single grouping pass that now also accumulates `operaciones` so
      // the ranking table below can compute averages without re-iterating
      // the per-day rows. Building grouped, donut data, and ranking off
      // the same dictionary keeps this O(n).
      let grouped = _(base).groupBy('sucursal_id')
        .map((sucursal, id) => {
          return {
            sucursal_id: id,
            total: _.sumBy(sucursal, 'total'),
            comensales: _.sumBy(sucursal, 'comensales'),
            operaciones: _.sumBy(sucursal, 'operaciones'),
          }
        })
        .value()
      let l = []
      let a1 = []
      let a2 = []
      // Grand total drives the "% del total" column. Reading it off the
      // same `grouped` array avoids depending on this.ventasSum (which is
      // set asynchronously in getsalesreport and may not be final yet
      // when this method runs).
      const grandTotal = _.sumBy(grouped, 'total')
      const ranking = []
      _.forEach(grouped, function (v) {
        let suc = _.find(that.sucursales, function (s) {
          return s.id == v.sucursal_id
        })
        let nombre = ""
        if (suc != undefined) {
          nombre = suc.nombre
        }
        l.push(nombre)
        a1.push(v.total)
        a2.push(v.comensales)
        ranking.push({
          sucursal_id: v.sucursal_id,
          nombre,
          total: v.total || 0,
          operaciones: v.operaciones || 0,
          comensales: v.comensales || 0,
          avg_ticket: v.operaciones > 0 ? v.total / v.operaciones : 0,
          avg_per_person: v.comensales > 0 ? v.total / v.comensales : 0,
          share: grandTotal > 0 ? (v.total / grandTotal) * 100 : 0,
        })
      })
      // b-table handles its own sorting; preseeding by total desc is just
      // for the unsorted initial render and CSV exports.
      ranking.sort((a, b) => b.total - a.total)
      this.sucursalRanking = ranking
      this.salesBySucursalDonutChart.labels = l
      this.salesBySucursalDonutChart.datasets[0].data = a1
      this.salesBySucursalDonutChart.datasets[0].backgroundColor = this.colorsArray
      this.comensalesBySucursalDonutChart.labels = l
      this.comensalesBySucursalDonutChart.datasets[0].data = a2
      this.comensalesBySucursalDonutChart.datasets[0].backgroundColor = this.colorsArray
      this.salesBySucursalDonutChart.show = true
      this.comensalesBySucursalDonutChart.show = true
      // this.salesBySucursalDonutChart.datasets[0].backgroundColor = clrs
      // this.salesBySucursalDonutChart.datasets[0].borderColor = clrs
    },
    selectColor(colorNum, colors) {
      if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
      return "hsl(" + (colorNum * (360 / colors) % 360) + ",100%,50%)";
    },
    changeDate() {
      this.setDateRange()
      this.getsalesreport()
      this.getProjectedReport()
      this.getPopularidad()
      this.getSalesByArea()
    },
    // rebuildSalesChart collapses the cached daily maps (salesByDayMap +
    // projectedByDayMap) into the bucket labels of the currently resolved
    // granularity and pushes them into nsalesChart. Cheap (O(days)), no
    // network call. Invoked by the granularity <select> @change and also
    // by getsalesreport / getProjectedReport once their daily data is in.
    //
    // IMPORTANT: this touches only nsalesChart. It must NOT call
    // setDateRange because that also rewrites salesBySucursalLineChart.labels
    // back to daily, which would wipe out the monthly/weekly labels
    // setVentasPorsucursalPorDia just installed on the per-sucursal chart.
    rebuildSalesChart() {
      const labels = this.buildSalesBucketKeys()
      this.nsalesChart.labels = labels
      const totalsByBucket = {}
      const projByBucket = {}
      for (const key of labels) {
        totalsByBucket[key] = 0
        projByBucket[key] = 0
      }
      for (const day in this.salesByDayMap) {
        const k = this.bucketKeyForDate(day)
        if (k in totalsByBucket) {
          totalsByBucket[k] += this.salesByDayMap[day]
        }
      }
      for (const day in this.projectedByDayMap) {
        const k = this.bucketKeyForDate(day)
        if (k in projByBucket) {
          projByBucket[k] += this.projectedByDayMap[day]
        }
      }
      // Round to two decimals for display; Chart.js handles the rest.
      const round = (v) => Math.round((v + Number.EPSILON) * 100) / 100
      this.nsalesChart.datasets[0].data = labels.map((k) => round(totalsByBucket[k]))
      this.nsalesChart.datasets[1].data = labels.map((k) => ({
        x: k,
        y: round(projByBucket[k]),
      }))
    },
    getSalesByArea() {
      if (!this.hasPermission("rrn:central:reports:dailyReport")) {
        return
      }
      let that = this
      that.salesByAreaLoading = true
      that.salesByAreaDonutChart.show = false
      let payload = {
        initial_date: moment(this.initialDate).format("YYYY-MM-DD"),
        end_date: moment(this.lastDate).format("YYYY-MM-DD"),
        sucursales: this.allSucsArray,
      }
      axios
        .post("/report/dates/area/summary", payload)
        .then(function (r) {
          // Backend already aggregates and sorts. We just feed it into the
          // chart and the small companion table — no client-side grouping.
          let rows = r.data || []
          let total = rows.reduce((p, a) => p + (a.total_converted || a.total || 0), 0)
          that.salesByAreaTotal = Math.round((total + Number.EPSILON) * 100) / 100
          that.salesByAreaDonutChart.labels = rows.map(x => x.restaurant_area_name || "Sin área")
          that.salesByAreaDonutChart.datasets[0].data = rows.map(
            x => Math.round(((x.total_converted || x.total || 0) + Number.EPSILON) * 100) / 100
          )
          that.salesByAreaDonutChart.datasets[0].backgroundColor = that.colorsArray
          // Numeric raw values in the row so b-table sorts correctly;
          // formatting (currency, %) happens in the #cell templates so
          // the displayed string never gets sorted alphabetically.
          that.salesByAreaTable = rows.map((x) => {
            const ventas = x.total_converted || x.total || 0
            const operaciones = x.operaciones || 0
            const comensales = x.comensales || 0
            return {
              area: x.restaurant_area_name || "Sin área",
              total: ventas,
              operaciones,
              comensales,
              avg_ticket: operaciones > 0 ? ventas / operaciones : 0,
              avg_per_person: comensales > 0 ? ventas / comensales : 0,
              share: total > 0 ? (ventas / total) * 100 : 0,
            }
          })
          that.salesByAreaDonutChart.show = true
        })
        .catch(function (err) {
          console.error(err)
          let msg = err.response?.data || err.message || "Error al cargar ventas por área"
          that.makeToast("Error", msg, "danger")
        })
        .finally(() => {
          that.salesByAreaLoading = false
        })
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  }
}
</script>